/**
 * Get the server URL based on dev mode
 * @returns {string} Server URL
 */
export const getServerUrl = () => {
    return window.devMode ? 'http://localhost:80' : '';
};

// The following prototype code is commented out (test code with top-level await)
// await fetch('/Task/submit?' + new URLSearchParams({
//     type: 'facial_landmark@128'
// }),
//     { method: "POST", body: document.getElementById("demo").files[0] }).then(async res => res.text())
